const Footer = () => {
  return (
    <footer>
      <span>&copy; 2025 - Tous droits reservés</span>
    </footer>
  );
};

export default Footer;
